module.exports = __webpack_public_path__ + "img/member_birthday.6099a055.png";